import { useEffect, useState } from "react";
import { useSearchParams, useNavigate } from "react-router-dom";
import { CheckCircle, Clock, XCircle } from "@phosphor-icons/react";
import { api } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";

export default function PagoRetorno() {
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { refresh } = useAuth();
  const [state, setState] = useState({ status: "loading", msg: "Confirmando tu pago…" });

  useEffect(() => {
    const paymentId = params.get("payment_id");
    const redirectStatus = params.get("status");
    if (!paymentId) {
      setState({ status: redirectStatus === "approved" ? "ok" : "pending", msg: `Pago ${redirectStatus || "sin identificador"}.` });
      return;
    }
    api.get(`/company/mp-status?payment_id=${encodeURIComponent(paymentId)}`)
      .then(async ({ data }) => {
        if (data.status === "approved") { await refresh(); setState({ status: "ok", msg: "¡Pago aprobado! Tu licencia se renovó por 12 meses." }); }
        else setState({ status: "pending", msg: `Pago en estado: ${data.status}. Te avisaremos al aprobarse.` });
      })
      .catch(() => setState({ status: "pending", msg: "Pago recibido; esperando confirmación." }));
  }, [params, refresh]);

  const Icon = state.status === "ok" ? CheckCircle : state.status === "pending" ? Clock : XCircle;
  const color = state.status === "ok" ? "text-emerald-500" : state.status === "pending" ? "text-amber-500" : "text-red-500";

  return (
    <div className="min-h-screen flex items-center justify-center bg-background p-6" data-testid="pago-retorno">
      <div className="max-w-md w-full bg-card border border-border rounded-lg p-8 text-center">
        <Icon size={56} weight="fill" className={`mx-auto mb-4 ${color}`} />
        <h1 className="text-xl font-display font-bold mb-2">Renovación de licencia</h1>
        <p className="text-sm text-muted-foreground mb-6">{state.msg}</p>
        <Button className="w-full rounded-lg" data-testid="retorno-continuar" onClick={() => navigate("/dashboard", { replace: true })}>
          Continuar al sistema
        </Button>
      </div>
    </div>
  );
}
